const baseCart = {
    items:[], 
    sum: 0, 
    instructions: "",
    discount: null
}

export function emptyCart(sid){
    try{
    const storage = JSON.parse(localStorage.getItem("cart"))
    delete storage?.[sid]
    localStorage.setItem("cart", JSON.stringify(storage))
    return true
    }
    catch(e){
        console.log(e)
        return false
    }

}

export function fetchCart(sid){
    try{
        const storage = JSON.parse(localStorage.getItem("cart"))
        return storage?.[sid] ?? baseCart
    }catch{
        return baseCart
    }
}

export function fetchFullCart(){
    try{
        return JSON.parse(localStorage.getItem("cart")) ?? {}
    }catch{
        return {}
    }
}


export function setCart(sid, items, sum){
    try{
        let storage = JSON.parse(localStorage.getItem("cart")) ?? {}
        storage[sid] = {...baseCart, items, sum}
        localStorage.setItem("cart",JSON.stringify(storage))

        return true;

    }catch(e){
        console.log(e)
        return false
    }
}

export function setDiscountStorage(sid, discount){
    console.log(discount)
    const storage = JSON.parse(localStorage.getItem("cart"))
    storage[sid].discount = discount
    localStorage.setItem("cart",JSON.stringify(storage))
}

export function editInstruction(sid, string) {
    const storage = fetchFullCart(sid);
    storage[sid].instructions = string;
    localStorage.setItem("cart", JSON.stringify(storage))
}


